<template>
  <div class="dqyxfx-warp">
    <resize-container :tabShow="tabShow">
      <div class="left-content" v-show="tabShow" slot="left">
        <tab-tree
          :data="viewTreeData"
          @tabTreeDefault="tabTreeDefault"
          @tabTreeClick="tabTreeClick"
          @changeCompany="changeCompany"
        ></tab-tree>
      </div>
      <div class="right-content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="dn-content-bg box1">
          <time-search
            ref="timeSearch"
            :control="{ data: timeData }"
            @timeControlChange="timeControlChange"
            @timeControlClick="TimeControlClick"
          >
          </time-search>
        </div>
        <div class="tab-pane">
          <nk-chart1
            :data="chartData"
            :timeTitle="timeTitle"
            :title="chartstitle"
            :unit="unit"
            :showAddBtn="showCheckBox"
            :isIrregularity="false"
            :activeName="activeName"
            :markLine="markLine"
            @clickoTherAdd="clickoTherAdd"
            class="box-magin"
            :max="max"
          ></nk-chart1>
          <div class="bg-box box-magin" v-if="showTell" style="color:#2e3842">
            <div>
              <span>月平均功率因数:</span>
              <span>{{ this.glyssj }}</span>
            </div>
            <div>节能建议:</div>
            <div style="display:inline">
              {{ this.tellData }}
              <p
                :style="
                  this.tip == '需改进, 建议进行电容补偿'
                    ? 'font-size:40px;color:#333'
                    : 'font-size:40px;color:#52CCA3'
                "
              >
                {{ this.tip }}
              </p>
            </div>
          </div>
        </div>
        <el-dialog
          title="添加对标线"
          :visible.sync="dialogFormVisible"
          width="30%"
          @open="opnedialog()"
          :destroy-on-close="true"
        >
          <el-form :model="Visibleform">
            <ul class="ulbox">
              <li v-for="(item, index) in checkData" :key="index">
                <el-checkbox
                  :label="item.name"
                  @change="changeSelect(item)"
                ></el-checkbox>
              </li>
            </ul>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="clicksummit('cancel')">取 消</el-button>
            <el-button type="primary" @click="clicksummit('sure')"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </div>
    </resize-container>
  </div>
</template>
<script>
import { findDataByParam } from "@/utils/index.js";
import * as utils from "@/utils/index.js";
import NkChart1 from "@/components/common/NkChart1.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import TabTree from "@/components/common/TabTree.vue";
import handleData from "@/utils/handleData.js";
import dateTool from "@/utils/dateTool";
import { isNull, isUndefined } from "util";
import ResizeContainer from "@/components/common/resizeContainer.vue";
import moment from "moment";
import dayjs from "dayjs";
let allTimeData = [
  {
    type: "month",
    label: "月",
  },
];
export default {
  components: {
    TimeSearch,
    TabTree,
    NkChart1,
    ResizeContainer,
  },
  data() {
    return {
      tall: "",
      options1: [
        {
          value: "219",
          label: "总功率因数",
        },
        {
          value: "220",
          label: "A相功率因数",
        },
        {
          value: "221",
          label: "B相功率因数",
        },
        {
          value: "222",
          label: "C相功率因数",
        },
      ],
      value1: "219",
      checkList: "",
      getvalue: "",
      selectCode: [],
      input: 0.8,
      markLine: null,
      dialogFormVisible: false,
      allTime: "",
      badvalue: "",
      goodfont: false,
      goodfont1: false,
      timeData: allTimeData,
      tabShow: true,
      Visibleform: {
        value: "",
      },
      //传入的计量点id
      queryId: "",
      viewId: "",
      selectNode: [],
      defaultCheckedKeys: [],
      toTime: "toTime",
      alarnclass: "alarnclass",
      showSearchTimeType: true,
      hideShowSearchTimeType: true,
      searchTimeType: "2",
      elem: {},
      activeName: "", //设置默认选中
      codes: [
        {
          code: "207",
          title: "A相",
        },
        {
          code: "208",
          title: "B相",
        },
        {
          code: "209",
          title: "C相",
        },
      ],
      columns: [],
      tableData: [],
      tableData1: [],
      chartData: [],
      unit: "",
      timeTitle: "",
      showEleWork: false,
      eleWorkData: [],
      measure: [],
      isDoubleY: false,
      isIrregularity: false,
      showCheckBox: false,
      showCheckBoxContent: false,
      checkDataTemp: [],
      checkData: [],
      chartstitle: "平均功率因数曲线",
      glyssj: "",
      tellData: "",
      showTell: false,
      tip: "",
      max: "1",
      viewTreeData: [],
      selectedDate: {},
    };
  },
  created() {},
  activated() {},
  methods: {
    bindShowCheckBoxContent() {
      let vm = this;
      vm.showCheckBoxContent = !vm.showCheckBoxContent;
    },
    changeCompany(companyId) {
      let vm = this;
      vm.columns = [
        { prop: "measureName", width: 200, label: "监测点名称" },
        { prop: "title", label: "相序" },
        { prop: "max", label: "最大功率值" },
        { prop: "maxTime", label: "最大功率值发生时间" },
        { prop: "min", label: "最小功率值" },
        { prop: "minTime", label: "最小功率值发生时间" },
      ];
      vm.$api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(
          companyId,
          "/nyyh/averagePowerFactor",
          null
        )
        .then((res) => {
          if (res) {
            const viewTreeData = findDataByParam("viewTree", true, res.data);
            vm.viewTreeData = viewTreeData;
          }
        });
    },
    /* 树加载 */
    tabTreeDefault(e) {
      this.selectNodes = [e];
      this.defaultCheckedKeys = [e.measureId];
      this.selectNodes = [{ id: e.measureId, label: e.measureName }];
      let startTime = moment()
        .startOf("month")
        .format("yyyy/MM/DD 00:00:00");
      let endTime = moment()
        .endOf("month")
        .format("yyyy/MM/DD 23:59:59");
      this.selectedDate = {
        dataType: "2",
        dateType: "month",
        startTime: startTime,
        endTime: endTime,
      };
      this.TimeControlClick(this.selectedDate);
    },
    /* 树点击 */
    tabTreeClick(e) {
      this.tableData1 = [];
      this.goodfont = false;
      this.goodfont1 = false;
      this.selectNodes = [{ id: e.measureId, label: e.measureName }];
      this.TimeControlClick(this.selectedDate);
    },
    timeControlChange() {},
    /* 查询 */
    TimeControlClick(e) {
      this.selectedDate = e;
      this.tableData1 = [];
      this.goodfont = false;
      this.goodfont1 = false;
      this.getData();
    },
    handleClick(tab) {
      let vm = this;
      vm.getData();
    },
    getData() {
      let vm = this;
      let codes;
      if (this.value1 == 219) {
        codes = [{ code: "219", title: "日平均功率因数", show: true }];
      } else if (this.value1 == 220) {
        codes = [{ code: this.value1, title: "A相功率因数", show: true }];
      } else if (this.value1 == 221) {
        codes = [{ code: this.value1, title: "B相功率因数", show: true }];
      } else if (this.value1 == 222) {
        codes = [{ code: this.value1, title: "C相功率因数", show: true }];
      }

      vm.getLoadRateData(codes);
    },
    getLoadRateData(codes) {
      let vm = this;

      if (vm.searchTimeType == "2") {
        vm.isIrregularity = true;
        let today = {
          startDate: vm.selectedDate.startTime,
          endDate: vm.selectedDate.endTime,
        };
        vm.$api.measuring
          .getMeasuringValueMaxMinDay(
            vm.selectNodes[0].id,
            vm.selectedDate.startTime,
            vm.selectedDate.endTime,
            "219",
            0
          )
          .then((res) => {
            let xData = handleData.createXData(
              vm.selectedDate.dateType,
              today.startDate,
              today.endDate
            );
            let data = handleData.matchEleDataOther(
              res.data,
              xData,
              vm.selectNodes,
              ["日平均功率因数"],
              false
            );
            vm.timeTitle =
              vm.selectedDate.startTime + "~" + vm.selectedDate.endTime;
            let line = {
              data: [],
              lineStyle: {
                normal: {
                  color: "#fc4136", // 这儿设置安全基线颜色
                },
              },
            };
            line.data.push({
              yAxis: 0.9,
              name: "aaa",
            });
            vm.markLine = line;
            vm.chartData = data;
          });
        vm.$api.measuring
          .getMeasuringValueMaxMinMonth(
            vm.selectNodes[0].id,
            dayjs(vm.selectedDate.startTime).format("YYYY/MM/01 00:00:00"),
            dayjs(vm.selectedDate.startTime)
              .endOf("M")
              .format("YYYY/MM/DD HH:mm:ss"),
            "219",
            0
          )
          .then((res) => {
            if (res.data.length == 0) {
              this.showTell = false;
              return;
            } else {
              this.showTell = true;
            }
            this.glyssj = Math.abs(res.data[0].avg);
            // this.glyssj =0.85
            if (this.glyssj >= 0.95) {
              this.glyssj = this.glyssj.toFixed(2);
              this.tellData = `月平均功率因数为 ${this.glyssj},大于国家标准值 0.9 , 当前评价: `;
              this.tip = "优秀";
            } else if (this.glyssj >= 0.9 && this.glyssj < 0.95) {
              this.glyssj = this.glyssj.toFixed(2);
              this.tellData = `月平均功率因数为 ${this.glyssj},处于国家标准值 0.9 - 0.95 之间, 当前评价: `;
              this.tip = "良好";
            } else {
              this.glyssj = this.glyssj.toFixed(2);
              this.tellData = `月平均功率因数为 ${this.glyssj},小于国家标准值 0.9  , 当前评价: `;
              this.tip = "需改进, 建议进行电容补偿";
            }
          });
      }
    },
    opnedialog() {
      let vm = this;
      this.$api.event
        .getEventDetectRegulations(vm.selectNodes[0].id, 0)
        .then((res) => {
          let params = res.data.filter((item, index, array) => {
            if (vm.value1 == "219") {
              return item.code == "8046";
            } else if (vm.value1 == "220") {
              return item.code == "8048";
            } else if (vm.value1 == "221") {
              return item.code == "8050";
            } else if (vm.value1 == "222") {
              return item.code == "8052";
            }
          });
          console.log(params); //[6, 4, 5]
          let thresholdData = [];
          for (let i = 0; i < params.length; i++) {
            if (vm.value1 == "219") {
              thresholdData.push({
                name:
                  params[i].code == "8045"
                    ? "总功率因数上限"
                    : "总功率因数下限",
                value: params[i].thresholdValue,
                code: params[i].code,
              });
            } else if (vm.value1 == "220") {
              thresholdData.push({
                name:
                  params[i].code == "8047"
                    ? "A相功率因数上限"
                    : "A相功率因数下限",
                value: params[i].thresholdValue,
                code: params[i].code,
              });
            } else if (vm.value1 == "221") {
              thresholdData.push({
                name:
                  params[i].code == "8049"
                    ? "B相功率因数上限"
                    : "B相功率因数下限",
                value: params[i].thresholdValue,
                code: params[i].code,
              });
            } else if (vm.value1 == "222") {
              thresholdData.push({
                name:
                  params[i].code == "8051"
                    ? "C相功率因数上限"
                    : "C相功率因数下限",
                value: params[i].thresholdValue,
                code: params[i].code,
              });
            }
          }
          vm.checkData = thresholdData;
        });
    },
    clicksummit(type) {
      let vm = this;
      if (type == "sure") {
        let vm = this;
        let line = {
          lineStyle: {
            normal: {
              color: "#fc4136", // 这儿设置安全基线颜色
            },
          },

          data: ["0.9"],
        };
        for (let i = 0; i < vm.selectCode.length; i++) {
          line.data.push({
            yAxis: Math.abs(parseFloat(vm.selectCode[i].value)),
            name: vm.selectCode[i].name,
          });
        }
        vm.markLine = line;
        let downData = [];
        for (let j = 0; j < vm.markLine.data.length; j++) {
          if (vm.markLine.data[j].name == "总功率因数下限") {
            downData.push(vm.markLine.data[j].yAxis);
          } else if (vm.markLine.data[j].name == "A相功率因数下限") {
            downData.push(vm.markLine.data[j].yAxis);
          } else if (vm.markLine.data[j].name == "B相功率因数下限") {
            downData.push(vm.markLine.data[j].yAxis);
          } else if (vm.markLine.data[j].name == "C相功率因数下限") {
            downData.push(vm.markLine.data[j].yAxis);
          }
        }
        let newData = [];
        vm.chartData.dataNew = [];
        newData = JSON.parse(JSON.stringify(vm.chartData[0].data[0]));
        if (newData != null && newData.length > 0) {
          let segs = [];
          let t = newData[0].value[0];
          let stateDown;
          let lineValue = Math.abs(downData[0]);
          let badMSeconds = 0;
          function getTimeDiff(strStartTime, strEndTime) {
            let t = strStartTime;
            let t1 = strEndTime;
            var date = new Date(t);
            var date1 = new Date(t1);
            return date1 - date;
          }
          if (newData[0].value[1] < lineValue) {
            stateDown = true;
          } else {
            stateDown = false;
          }
          for (let i = 0; i < newData.length; i++) {
            let v = newData[i].value[1];
            let t1 = newData[i].value[0];
            if (v < lineValue && !stateDown) {
              t = t1;
              stateDown = true;
            } else if (v >= lineValue && stateDown) {
              badMSeconds += getTimeDiff(t, t1);
              stateDown = false;
            }
          }
          if (stateDown) {
            let t1 = newData[newData.length - 1].value[0];
            badMSeconds += getTimeDiff(t, t1);
          }
          let a = vm.allTime.startTime;
          let b = vm.allTime.endTime;

          let total = getTimeDiff(a, b);
          let bad = vm.getHHMMSS(badMSeconds);
          let good = vm.getHHMMSS(total - badMSeconds);

          let totalMinute = getTimeDiff(a, b) / 1000 / 60;
          let badMinute = badMSeconds / 1000 / 60;
          let googMinute = totalMinute - badMinute;
          let badnum = (badMinute / totalMinute) * 100;
          let goodnum = (googMinute / totalMinute) * 100;

          let badMinute1 = (badMinute / 60).toFixed(3);
          let googMinute1 = (googMinute / 60).toFixed(3);
          let badnum1 = badnum.toFixed(2);
          let goodnum1 = goodnum.toFixed(2);
          vm.badvalue = badMinute;
          vm.tableData1 = [];
          vm.tableData1.push(
            {
              date: "正常时间",
              name: good,
              address: goodnum1 + "%",
            },
            {
              date: "越下限时间",
              name: bad,
              address: badnum1 + "%",
            }
          );
        }
        if (vm.badvalue === 0) {
          vm.goodfont = false;
          vm.goodfont1 = true;
        } else if (vm.badvalue !== 0) {
          vm.goodfont = true;
          vm.goodfont1 = false;
          vm.tall = "功率因数低于下限值，请检查";
        }
        this.TimeControlClick(this.selectedDate);
      } else {
      }
      this.dialogFormVisible = false;
    },
    getHHMMSS(msd) {
      var time = parseFloat(msd) / 1000;
      if (null != time && "" != time) {
        if (time > 60 && time < 60 * 60) {
          time =
            parseInt(time / 60.0) +
            "分" +
            parseInt((parseFloat(time / 60.0) - parseInt(time / 60.0)) * 60) +
            "秒";
        }
        // else if (time >= 60 * 60 && time < 60 * 60 * 24) {
        else if (time >= 60 * 60) {
          time =
            parseInt(time / 3600.0) +
            "时" +
            parseInt(
              (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
            ) +
            "分" +
            parseInt(
              (parseFloat(
                (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
              ) -
                parseInt(
                  (parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60
                )) *
                60
            ) +
            "秒";
        } else {
          time = parseInt(time) + "秒";
        }
      }
      return time;
    },
    clickoTherAdd() {
      this.selectCode = [];
      this.dialogFormVisible = true;
    },
    changeSelect(e) {
      this.selectCode.push(e);
    },
    getDate(tm) {
      var tt = new Date(parseInt(tm) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ");
      return tt;
    },
  },
};
</script>
<style lang="scss" scoped>
.ulbox {
  display: flex;
  flex-wrap: wrap;
}
.ulbox > li {
  line-height: 30px;
  font-size: 18px;
  list-style: none;
  width: 50%;
}

.dqyxfx-warp {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  overflow: hidden;
}
.left-content {
  height: 100%;
  width: 100%;
}
.right-content {
  overflow: auto;
  flex: 1;
  display: flex;
  flex-flow: column;
  height: 100%;
}
.top {
  line-height: 40px;
}
.top ul {
  overflow: hidden;
  list-style: none;
  padding: 0;
  margin: 0;
}
.top ul li {
  float: left;
  font-size: 16px;
  margin-right: 20px;
  line-height: 30px;
}
.top ul li:first-child {
  margin-left: 0px;
}
.red {
  color: #ed6a93;
}
.tab-pane {
  position: relative;
}
.check-box {
  position: absolute;
  top: 0px;
  right: 54px;
  width: 180px;
  height: 150px;
  z-index: 999;
  overflow: auto;
  box-shadow: 0px 0px 5px #bcbcbc;
}
.check-btn-img {
  position: absolute;
  right: 0px;
  top: 0px;
  padding: 6px;
  z-index: 999;
  border-radius: 4px;
  box-shadow: 0px 0px 5px #bcbcbc;
}
.check-btn {
  position: absolute;
  right: 10px;
  top: 4px;
  z-index: 999;
  cursor: pointer;
}
.check-box ul {
  width: 100%;
  list-style: none;

  margin: 0px;
  padding: 0px;
}
.check-box ul li {
  padding: 4px;
}

.top {
  line-height: 40px;
  background: #fff;
  border-radius: 4px;

  padding: 14px;
  box-sizing: content-box;
}

.box-magin {
  margin-top: 14px;
}
.bg-box {
  background: #fff;
  border-radius: 4px;
  padding: 14px;
  box-sizing: content-box;
  border: 1px solid #dedcdc;
}

.tab {
  border: 1px solid #dedcdc;
  border-radius: 4px;
}
.tab
  >>> .el-tabs--top.el-tabs--card
  > .el-tabs__header
  .el-tabs__item:nth-child(2) {
  padding: 0px;
}
.tab >>> .el-tabs__nav-scroll {
  border-radius: 4px;
  background: #dbdbdb;
}
.tab >>> .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0px;
}
.tab >>> .el-tabs--card > .el-tabs__header {
  border: 0px;
}
.tab >>> .el-tabs__item {
  height: 64px;
  line-height: 64px;
  width: 100px;
  text-align: center;
  padding: 0px;
  border: none !important;
  color: #000;
  font-weight: bold;
}
.tab >>> .el-tabs__item.is-active {
  /* background: #fff;
  border: 1px solid #fff; */

  color: #1d6ce9;
  border-bottom: 6px solid #1d6ce9 !important;
}
.tab >>> .el-tabs__header {
  margin: 0px;
}
.tab >>> .el-tabs__content {
  background: #fff;
  border-radius: 4px;
}
.tab >>> .ele-work-warp {
  margin-top: 14px;
}
.box1 {
  padding: 5px;
  box-sizing: border-box;
  color: #2e3842;
}
</style>
